const getters = {
  token: state => state.user.token,
  refreshtoken: state => state.user.refreshtoken,
  openid: state => state.user.openid,
  isbind: state => state.user.isbind,
  img: state => state.user.img,
  nav: state => state.user.nav,
  navIndex: state => state.user.navIndex,
  dictionary: state => state.user.dictionary,
  name: state => state.user.name,
  userid: state => state.user.userid,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js